module.exports = {
  Url: "https://bayin.app/api/v1/",
  // Url: "http://43.204.250.254:6300/api/v1/",
  // Url: "http://192.168.0.177:6300/api/v1/",
};
